<template>
  <v-layout align-start>
    <v-flex>
      <v-app-bar>
        <v-toolbar-title class="font-weight-black primary--text"
          >Grupo Nóminas</v-toolbar-title
        >
        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="mostrarCarga"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> file_upload </v-icon>
            </v-btn>
          </template>
          <span>Carga masiva de datos</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              large
              @click="addItem"
              color="primary"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon dark> add </v-icon>
            </v-btn>
          </template>
          <span>Ingresar nuevo registro</span>
        </v-tooltip>
      </v-app-bar>
      <v-data-table
        dense
        :headers="headers"
        :items="grupo_nominas"
        :items-per-page="2"
        :search="search"
        sort-by="codigo"
        class="elevation-1"
        :header-props="{ 'sort-icon': 'fa-solid fa-arrow-down-wide-short' }"
        :footer-props="{
          showFirstLastPage: true,
          'items-per-page-text': 'Filas por página',
          'items-per-page-options': [-1, 50, 100, 150],
        }"
      >
        <template v-slot:[`item.opciones`]="{ item }">
          <v-btn x-small text dark color="primary" @click="editItem(item)">
            <v-icon x-small>edit</v-icon>
          </v-btn>
        </template>

        <template v-slot:[`item.estado`]="{ item }">
          <div v-if="item.estado == 'A'">
            <v-btn color="success" x-small text dark @click="desactivar(item)">
              <v-icon x-small>check</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-btn color="error" x-small text dark @click="activar(item)">
              <v-icon x-small>block</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:[`item.es_planilla`]="{ item }">
          <div v-if="item.es_planilla == true">
            <v-btn color="success" x-small text dark>
              <v-icon x-small>check</v-icon>
            </v-btn>
          </div>
          <div v-else>
            <v-btn color="error" x-small text dark>
              <v-icon x-small>block</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title class="font-weight-black primary--text">
            </v-toolbar-title>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="search"
              append-icon="search"
              label="Búsqueda General"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchCodigoValue"
              append-icon="search"
              label="Búsqueda por código"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-text-field
              outlined
              dense
              class="text-xs-center"
              v-model="searchDescripcionValue"
              append-icon="search"
              label="Búsqueda por descripción"
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>

            <v-dialog v-model="dialog" max-width="500px">
              <v-card ref="form">
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          dense
                          ref="codigo"
                          v-model="codigo"
                          :readonly="!editCodigo"
                          :rules="[rules.requerido, rules.max10, rules.min2]"
                          :error-messages="errorMessages"
                          label="Código"
                          placeholder="Código"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          outlined
                          dense
                          ref="descripcion"
                          v-model="descripcion"
                          :rules="[rules.requerido, rules.max50, rules.min2]"
                          :error-messages="errorMessages"
                          label="Descripción"
                          placeholder="Descripción"
                          required
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="12" md="12">
                        <v-checkbox v-model="es_planilla">
                          <template v-slot:label>
                            <div>Se incluye en Planillas</div>
                          </template>
                        </v-checkbox>
                      </v-col>
                    </v-row>

                    <v-row v-show="editedIndex == true">
                      <v-flex>
                        <v-data-table
                          dense
                          :headers="headersSubcategoria"
                          :items="Subcategorias"
                          :search="searchSubcategoria"
                          :page.sync="page"
                          :items-per-page="itemsPerPage"
                          sort-by="descripcion"
                          class="elevation-1"
                          :header-props="{
                            'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                          }"
                          :footer-props="{
                            showFirstLastPage: true,
                            'items-per-page-text': 'Filas por página',
                            'items-per-page-options': [-1, 50, 100, 150],
                          }"
                        >
                          <template v-slot:[`item.opciones`]="{ item }">
                            <v-btn
                              text
                              x-small
                              dark
                              color="primary"
                              @click="deleteItemSubcategoria(item)"
                            >
                              <v-icon x-small>delete</v-icon>
                            </v-btn>
                          </template>
                          <template v-slot:top>
                            <v-toolbar flat color="white">
                              <v-spacer></v-spacer>
                              <v-spacer></v-spacer>

                              <v-dialog
                                dense
                                v-model="dialogSubcategoria"
                                max-width="500px"
                              >
                                <template v-slot:activator="{ on }">
                                  <div v-on="on"></div>

                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        class="mx-2"
                                        color="primary"
                                        @click="addSubcategoria"
                                        v-bind="attrs"
                                        v-on="on"
                                      >
                                        <v-icon dark> add </v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Ingresar nueva Subcategoria</span>
                                  </v-tooltip>
                                </template>
                                <v-card ref="formSubcategoria">
                                  <v-card-title>
                                    <span class="headline"
                                      >Datos Subcategoria</span
                                    >
                                  </v-card-title>
                                  <v-card-text>
                                    <v-container>
                                      <v-row>
                                        <v-col cols="12" sm="12" md="12">
                                          <v-autocomplete
                                            outlined
                                            dense
                                            ref="id_categoria"
                                            v-model="id_categoria"
                                            :items="CategoriasList"
                                            @change="selectSubcategoria"
                                            :rules="[]"
                                            :error-messages="
                                              errorMessagesSubcategoria
                                            "
                                            item-text="descripcion"
                                            item-value="id"
                                            label="Categoria"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="12">
                                          <v-autocomplete
                                            outlined
                                            dense
                                            chips
                                            deletable-chips
                                            multiple
                                            rounded
                                            small-chips
                                            ref="id_subcategoria"
                                            v-model="id_subcategoria"
                                            :items="SubcategoriasList"
                                            :readonly="editedIndexCco"
                                            :rules="[]"
                                            :error-messages="
                                              errorMessagesSubcategoria
                                            "
                                            item-text="descripcion"
                                            item-value="id"
                                            label="Subcategoria"
                                            required
                                          ></v-autocomplete>
                                        </v-col>
                                      </v-row>
                                    </v-container>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="closeSubcategoria"
                                      >Cancelar</v-btn
                                    >
                                    <v-btn
                                      color="blue darken-1"
                                      text
                                      @click="guardarSubcategoria"
                                      >Guardar</v-btn
                                    >
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                              <v-dialog
                                v-model="dialogBorrarSubcategoria"
                                persistent
                                max-width="290"
                              >
                                <v-card>
                                  <v-card-title class="headline"
                                    >¿Está seguro?</v-card-title
                                  >
                                  <v-card-text
                                    >Esta acción borrará la asignación de
                                    Subcategoria al grupo.</v-card-text
                                  >
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      text
                                      @click="dialogBorrarSubcategoria = false"
                                      >Cancelar</v-btn
                                    >
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="eliminarSubcategoria()"
                                      >Continuar</v-btn
                                    >
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-toolbar>
                          </template>
                          <template v-slot:no-data>
                            <v-btn
                              color="primary"
                              @click="listarGrupoNominaSubcategoria"
                              >Reset</v-btn
                            >
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="close">Cancelar</v-btn>
                  <v-btn color="primary" text @click="guardar">Guardar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" @click="listar">Reset</v-btn>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogUpload" max-width="50%">
        <v-card>
          <v-card-title>
            <span class="headline">Carga Masiva de Datos</span>
          </v-card-title>
          <v-card-text>
            <v-file-input
              dense
              id="file"
              ref="file"
              v-model="file"
              @change="archivoCambiado"
              show-size
              chips
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              prepend-icon="cancel_presentation"
              placeholder="Seleccione un archivo Excel"
            >
              <template v-slot:selection="{ text }">
                <v-chip color="primary">
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
            <v-spacer></v-spacer>
            <div v-show="mostrarErrores">
              <v-textarea
                outlined
                dense
                ref="error"
                v-model="error"
                :rules="[]"
                :readonly="true"
                :error-messages="errorMessages"
                label="Lista de Errores"
                placeholder="Lista de Errores"
                required
              ></v-textarea>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeUpload">Cancelar</v-btn>
            <v-btn color="primary" text @click="guardarExcel">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      grupo_nominas: [],

      dialog: false,
      dialogUpload: false,
      dialogSubcategoria: false,
      dialogBorrarSubcategoria: false,
      editedIndexCco: false,
      es_planilla: false,
      page: 1,
      itemsPerPage: 12,
      headers: [
        {
          text: "Opciones",
          value: "opciones",
          sortable: false,
          width: "10%",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Código",
          value: "codigo",
          align: "left",
          filter: this.filtroCodigo,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "descripcion",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Incluido en Planillas",
          value: "es_planilla",
          filter: this.filtroDescripcion,
          align: "left",
          class: "primary white--text text-subtitle-2",
        },

        {
          text: "Activo",
          value: "estado",
          align: "center",
          class: "primary white--text text-subtitle-2",
        },
      ],

      headersSubcategoria: [
        {
          text: "Subcategoria",
          value: "codigo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Descripción",
          value: "subcategoria",
          class: "primary white--text text-subtitle-2",
        },

        {
          text: "Opciones",
          value: "opciones",
          align: "center",
          sortable: false,
          width: "10%",
          class: "primary white--text text-subtitle-2",
        },
      ],

      rules: {
        requerido: (value) => !!value || "Debe llenar este campo.",
        numero: (value) => {
          const pattern = /^\d*\.?\d*$/;
          return pattern.test(value) || "Ingrese un número válido.";
        },
        GestionMin: (value) => value >= 1950 || "Ingrese una gestión superior.",
        GestionMax: (value) => value <= 2200 || "Ingrese una gestión inferior.",
        min2: (value) =>
          value.length >= 2 || "El campo tiene que tener mas de 2 caracteres.",
        min5: (value) =>
          value.length >= 5 || "El campo tiene que tener mas de 5 caracteres.",
        max10: (value) =>
          value.length <= 10 || "El campo debe tener menos de 10 caracteres.",
        max25: (value) =>
          value.length <= 25 || "El campo debe tener menos de 25 caracteres.",
        max30: (value) =>
          value.length <= 30 || "El campo debe tener menos de 30 caracteres.",
        max45: (value) =>
          value.length <= 45 || "El campo debe tener menos de 45 caracteres.",
        max50: (value) =>
          value.length <= 50 || "El campo debe tener menos de 50 caracteres.",
        max100: (value) =>
          value.length <= 100 || "El campo debe tener menos de 100 caracteres.",
        email: (value) => {
          const pattern = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4})*$/;
          return pattern.test(value) || "Ingrese un email válido.";
        },
      },

      search: "",
      searchSubcategoria: "",
      searchCodigoValue: "",
      searchDescripcionValue: "",

      SubcategoriasList: [],
      CategoriasList: [],
      Subcategorias: [],
      editedIndex: false,
      editCodigo: false,
      mostrarErrores: false,
      usuario: this.$store.state.usuario.user,
      id: "",
      id_subcategoria: "",
      id_categoria: "",
      codigo: "",
      descripcion: "",
      file: null,

      valida: 0,

      validaMensaje: [],

      adCodigo: "",
      errorMessages: "",
      errorMessagesSubcategoria: "",
      error: "",
    };
  },

  computed: {
    formTitle() {
      return this.editedIndex === false
        ? "Nuevo Registro"
        : "Actualizar Registro";
    },

    form() {
      return {
        codigo: this.codigo,
        descripcion: this.descripcion,
      };
    },

    formSubcategoria() {
      return {
        id_subcategoria: this.id_subcategoria,
      };
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    name() {
      this.errorMessages = "";
      this.errorMessagesSubcategoria = "";
    },
  },

  created() {
    this.listar();
    this.selectCategorias();
  },

  methods: {
    archivoCambiado(e) {
      this.selectedFile = e;
    },

    closeUpload() {
      this.dialogUpload = false;
      this.limpiarUpload();
    },
    closeSubcategoria() {
      this.dialogSubcategoria = false;
      this.listarGrupoNominaSubcategoria();
      this.limpiarSubcategoria();
    },

    guardarExcel() {
      let me = this;
      const formData = new FormData();

      if (this.selectedFile != null) {
        formData.append(this.selectedFile.name, this.selectedFile);
        axios
          .put("api/grupo_nominas/cargarExcel", formData)
          .then(function (response) {
            me.$store.dispatch("setSnackbar", {
              text: response.data,
              color: "success",
            });
            me.closeUpload();
            me.listar();
          })
          .catch(function (err) {
            me.mostrarErrores = true;
            me.$store.dispatch("setSnackbar", {
              text: "No se pudo cargar el archivo  seleccionado, verifique los errores e intente nuevamente.",
              color: "error",
            });
            me.error = err.response.data;
          });
      } else {
        formData.append(null, null);
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un archivo para cargar.",
          color: "warning",
        });
      }
    },

    listar() {
      let me = this;
      axios
        .get("api/grupo_nominas/listar")
        .then(function (response) {
          me.grupo_nominas = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    listarGrupoNominaSubcategoria() {
      let me = this;
      axios
        .get(
          "api/grupo_nomina_subcategorias/listarGrupoNominaSubcategoria/" +
            this.id
        )
        .then(function (response) {
          me.Subcategorias = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    selectCategorias() {
      let me = this;
      axios
        .get("api/categorias/select")
        .then(function (response) {
          me.CategoriasList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    selectSubcategoria() {
      let me = this;

      axios
        .get(
          "api/subcategorias/SelectDistintoGrupo/" +
            this.id +
            "/" +
            this.id_categoria
        )
        .then(function (response) {
          me.SubcategoriasList = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    mostrarCarga() {
      this.dialogUpload = true;
    },
    editItem(item) {
      this.id = item.id;
      this.codigo = item.codigo;
      this.descripcion = item.descripcion;
      this.es_planilla = item.es_planilla;
      this.editedIndex = true;
      this.editCodigo = false;
      this.dialog = true;
      this.listarGrupoNominaSubcategoria();
    },

    addItem() {
      this.editCodigo = true;
      this.dialog = true;
    },

    addSubcategoria() {
      this.dialogSubcategoria = true;
    },

    close() {
      this.dialog = false;
      this.limpiar();
    },

    limpiar() {
      this.id = "";
      this.codigo = "";
      this.descripcion = "";
      this.validaMensaje = [];
      this.editedIndex = false;
    },
    limpiarUpload() {
      this.file = null;
      this.selectedFile = null;
      this.error = "";
      this.mostrarErrores = false;
    },

    guardar() {
      if (this.validar() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }
      if (this.editedIndex == true) {
        //codigo para editar
        let me = this;
        axios
          .put("api/grupo_nominas/actualizar", {
            id: me.id,
            codigo: me.codigo,
            descripcion: me.descripcion,
            es_planilla: me.es_planilla,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro modificado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      } else {
        //codigo para guardar
        let me = this;
        axios
          .post("api/grupo_nominas/crear", {
            codigo: me.codigo,
            descripcion: me.descripcion,
            es_planilla: me.es_planilla,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.close();
            me.listar();
            me.limpiar();
            me.$store.dispatch("setSnackbar", {
              text: " Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    guardarSubcategoria() {
      if (this.validarSubcategoria() > 0) {
        this.$store.dispatch("setSnackbar", {
          text: "Verifique los errores e intente nuevamente.",
          color: "error",
        });
        return;
      }

      if (this.editedIndexCco) {
        let me = this;
        axios
          .put("api/grupo_nomina_subcategorias/actualizar", {
            id_grupo_nomina: me.id,
            id_subcategoria: me.id_subcategoria,
          })
          .then(function (response) {})
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", { text: error, color: "error" });
          });
      } else {
        let me = this;
        axios
          .post("api/grupo_nomina_subcategorias/crear", {
            id_grupo_nomina: me.id,
            id_subcategoria: me.id_subcategoria,
            usuario: me.usuario,
          })
          .then(function (response) {
            me.closeSubcategoria();
            me.listarGrupoNominaSubcategoria();
            me.limpiarSubcategoria();
            me.$store.dispatch("setSnackbar", {
              text: "Registro creado exitosamente.",
              color: "success",
            });
          })
          .catch(function (error) {
            me.$store.dispatch("setSnackbar", {
              text: error.response.data,
              color: "error",
            });
          });
      }
    },

    validar() {
      this.valida = 0;

      Object.keys(this.form).forEach((f) => {
        this.$refs[f].validate(true);
        if (this.$refs[f].validate(true)) {
          this.valida += 0;
        } else {
          this.valida += 1;
        }
      });
      return this.valida;
    },

    validarSubcategoria() {
      this.validaSubcategoria = 0;
      var elemento = "";
      var v = 0;
      var i = 0;
      Object.keys(this.formSubcategoria).forEach((f) => {
        this.$refs[f].validate(true);
        i++;
        if (this.$refs[f].validate(true)) {
          this.validaSubcategoria += 0;
        } else {
          if (v == 0) {
            v = i;
            elemento = f;
          }
          this.validaSubcategoria += 1;
        }
      });
      return this.validaSubcategoria;
    },

    activar(item) {
      let me = this;
      axios
        .put("api/grupo_nominas/activar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: " Registro activado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    desactivar(item) {
      let me = this;
      axios
        .put("api/grupo_nominas/desactivar/" + item.id, {})
        .then(function (response) {
          me.adCodigo = "";
          me.listar();
          me.$store.dispatch("setSnackbar", {
            text: "Registro desactivado exitosamente.",
            color: "success",
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    deleteItemSubcategoria(item) {
      this.id_subcategoria = item.id_subcategoria;
      this.dialogBorrarSubcategoria = true;
    },

    eliminarSubcategoria() {
      let me = this;

      axios
        .delete(
          "api/grupo_nomina_subcategorias/EliminarGrupoNominaSubcategoria/" +
            me.id +
            "/" +
            me.id_subcategoria,
          {}
        )
        .then(function (response) {
          me.listarGrupoNominaSubcategoria();

          me.$store.dispatch("setSnackbar", {
            text: "Subcategoria eliminada exitosamente.",
            color: "success",
          });
          me.dialogBorrarSubcategoria = false;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    limpiarSubcategoria() {
      this.id_subcategoria = "";
      this.id_grupo_nomina = "";

      //this.Subcategorias="";
      this.editedIndexCco = false;
    },

    filtroCodigo(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchCodigoValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value.toLowerCase().includes(this.searchCodigoValue.toLowerCase());
    },
    filtroDescripcion(value) {
      // If this filter has no value we just skip the entire filter.
      if (!this.searchDescripcionValue) {
        return true;
      }
      // Check if the current loop value (The dessert name)
      // partially contains the searched word.
      return value
        .toLowerCase()
        .includes(this.searchDescripcionValue.toLowerCase());
    },
  },
};
</script>
